import { useState, type ReactNode } from 'react';

const STORAGE_KEY = 'btpal_cookie_notice';

export function CookieBanner(): ReactNode {
    const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, '1');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
            <div className="max-w-lg mx-auto bg-white border border-[#E2E8F0] rounded-xl shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <p className="text-sm text-[#475569] leading-relaxed flex-1">
                    Ce site utilise uniquement des cookies essentiels au fonctionnement du service (authentification).
                    Aucun cookie publicitaire ou de suivi.{' '}
                    <a href="/politique-confidentialite" className="text-[#1D4ED8] hover:underline">
                        En savoir plus
                    </a>
                </p>
                <button
                    onClick={handleAccept}
                    className="shrink-0 px-4 py-2 bg-[#0F2744] text-white text-sm font-medium rounded-lg hover:bg-[#1A3A5C] transition-colors"
                >
                    Compris
                </button>
            </div>
        </div>
    );
}
